export const formatMileage = (miles: number): string => miles.toLocaleString('en-GB');

export const normaliseMileage = (value: string): string => value.replace(/[\s,]/g, '');
